"use strict";

class SuperPropertyViewController {

    constructor($scope, $timeout, SSHttpService, SSUtilService, SSAppService, SSAlertService, OTPService, SSUserService, SSConfigService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;
        self.FILTERS_STATUS = SHOWSUITE.FILTERS_STATUS;

        // Property Status
        self.propertyStatuses = self.SSConfigService.getPropertyStatuses();

        self.PROPERTY_STATUS_DRAFT = SHOWSUITE.PROPERTY_STATUS_DRAFT; // Just Created
        self.PROPERTY_STATUS_REVIEW = SHOWSUITE.PROPERTY_STATUS_REVIEW; // Submitted for Review
        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED; // Approved by the Showsuite Admin
        self.PROPERTY_STATUS_REJECTED = SHOWSUITE.PROPERTY_STATUS_REJECTED; // Approved by the Showsuite Admin
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED; // Listed on portal and publicly visible
        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED; // Archived

        self.PROPERTY_STATUS_MAP = {};
        self.PROPERTY_STATUS_MAP[self.PROPERTY_STATUS_DRAFT] = 'Draft';
        self.PROPERTY_STATUS_MAP[self.PROPERTY_STATUS_REVIEW] = 'Submitted for Review';
        self.PROPERTY_STATUS_MAP[self.PROPERTY_STATUS_APPROVED] = 'Approved';
        self.PROPERTY_STATUS_MAP[self.PROPERTY_STATUS_REJECTED] = 'Rejected';
        self.PROPERTY_STATUS_MAP[self.PROPERTY_STATUS_LISTED] = 'Listed';
        self.PROPERTY_STATUS_MAP[self.PROPERTY_STATUS_ARCHIVED] = 'Archived';

        self.PROPERTY_STATUS_CLASS_MAP = {};
        self.PROPERTY_STATUS_CLASS_MAP[self.PROPERTY_STATUS_DRAFT] = 'info';
        self.PROPERTY_STATUS_CLASS_MAP[self.PROPERTY_STATUS_REVIEW] = 'warning';
        self.PROPERTY_STATUS_CLASS_MAP[self.PROPERTY_STATUS_APPROVED] = 'success';
        self.PROPERTY_STATUS_CLASS_MAP[self.PROPERTY_STATUS_REJECTED] = 'danger';
        self.PROPERTY_STATUS_CLASS_MAP[self.PROPERTY_STATUS_LISTED] = 'success';
        self.PROPERTY_STATUS_CLASS_MAP[self.PROPERTY_STATUS_ARCHIVED] = 'info';

        self.PROPERTY_STATUS_SUPER_CHANGE_MAP = {};
        self.PROPERTY_STATUS_SUPER_CHANGE_MAP[self.PROPERTY_STATUS_REVIEW] = [self.PROPERTY_STATUS_APPROVED, self.PROPERTY_STATUS_REJECTED];
        // Property Status

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.filters = {
            status: self.FILTERS_STATUS
        };

        self.properties = [];
        self.all_properties = [];

        self.getAllProperties();
    }

    getAllProperties() {
        const self = this;

        let url = 'sec/super/properties';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.properties){
                self.all_properties = response.data.properties;
                self.getProperties();
            }
        });
    }

    getProperties() {
        const self = this;

        let status = self.filters.status;

        self.properties = self.all_properties;
        if( status ){ // Only filter properties if a filter status exists
            self.properties = self.all_properties.filter(x => x.property_status === status);
        }
    }

    getPropertyStatusText(property) {
        let self = this;

        return self.PROPERTY_STATUS_MAP[property.property_status];
    }

    getPropertyStatusClass(property) {
        let self = this;

        let cls = 'info';

        if (property.property_status in self.PROPERTY_STATUS_CLASS_MAP) {
            cls = self.PROPERTY_STATUS_CLASS_MAP[property.property_status];
        }

        return cls;
    }

    updatePropertyStatus(property, status) {
        let self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {

            let url = 'sec/developer/properties/' + property.named_id + '/update-status';
            let params = {
                status: status,
            };

            loading(true);
            self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                property.property_status = status;
            });
        });
    }

    savePropertyOrder() {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to order properties',
            self.SSConfirmationService.TYPE_DEFAULT,

            function () {
                let data = [];
                let count = self.properties['length'];

                jQuery.each($('#sortable li'), function (id, li_id) {
                    jQuery.each(self.properties, function (i, property) {
                        if (property['id'] == li_id['id']) {
                            property['featured'] = count;
                            count -= 1;
                            return false;
                        }
                    });
                });

                jQuery.each(self.properties, function (i, property) {
                    let property_data = {
                        property_id: property['id'],
                        featured: property['featured']
                    };
                    data.push(property_data);
                });

                let url = 'sec/super/properties/update-featured';

                loading(true);
                self.SSHttpService.putAPIRequest(url, {data: JSON.stringify(data)}).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        self.getProperties();
                        return;
                    }

                    self.getProperties();
                    self.SSAlertService.success('Success!', 'Properties successfully ordered.');
                });
            }
        );
    }

    // ********** Member Check Settings ************

    updateAMLSettings(amlSettings){
        const self = this;

        self.amlSettingsErrors = {};
        self.amlSettingsParams = angular.copy(amlSettings);

        if(!self.amlSettingsParams){

            self.amlSettingsParams = {
                "url": "api.membercheck.com",
                "api_key": null,
                "organisation_id": null,
                "scans_limit": null
            };
        }

        if(self.all_properties.length){
            self.getAllProperties();
            self.$timeout(function(){
                $('#amlSettingsModal').modal('show');
            });
        } else {
            $('#amlSettingsModal').modal('show');
        }
    }

    updatePropertySettings(property_id){
        const self = this;

        if(!property_id) return;

        let property = self.all_properties.find(x => x.id == property_id);

        if(property && property.member_check_api_key) {
            self.amlSettingsParams = JSON.parse(property.member_check_api_key);
            self.amlSettingsParams.property_id = property_id;
            self.amlSettingsParams.settings_exists = true;
        } else {
            self.amlSettingsParams = self.getDefaultAMLSettings(property_id);
        }     
    }

    saveAMLSettings(removeSettings = false){
        const self = this;

        if(!removeSettings && !self.isValidAmlScanInput(self.amlSettingsParams)) return;

        let amlSettingsJson = JSON.stringify(removeSettings? {} : self.amlSettingsParams);

        let url = "sec/super/properties/"+ self.amlSettingsParams.property_id +"/update-member-check-api-key";
        
        let params = {
            member_check_api_key: amlSettingsJson
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            $('#amlSettingsModal').modal('hide');

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.getProperties();
                return;
            }

            self.SSAlertService.success('Success!', 'Member check settings updated successfully.');
        });
    }

    getDefaultAMLSettings(property_id){
        return { url: "api.membercheck.com", property_id: property_id };
    }

    isValidAmlScanInput(params){
        const self = this;

        if(!params) return;

        self.amlSettingsErrors = {};
        let isValid = true;

        if(!params.property_id){
            self.amlSettingsErrors.property_id = "Please select a project.";
            isValid = false;
        }
        if(!params.url){
            self.amlSettingsErrors.url = "Please enter setting url.";
            isValid = false;
        }
        if(!params.api_key){
            self.amlSettingsErrors.api_key = "Please enter the api key.";
            isValid = false;
        }
        if(!params.organisation_id){
            self.amlSettingsErrors.organisation_id = "Please enter the organisation id.";
            isValid = false;
        }
        if(!params.scans_limit){
            self.amlSettingsErrors.scans_limit = "Please enter the api scans limit.";
            isValid = false;
        } else if(params.scans_limit &&  params.scans_limit < 0){
            self.amlSettingsErrors.scans_limit = "Please enter a positive value.";
            isValid = false;
        }

        return isValid;
    }

    // ********** App Target Settings (KeyHandover QR — WEB-3396) ************

    updateAppTargetSettings(){
        const self = this;

        self.appTargetSettingsErrors = {};
        self.appTargetSettingsParams = {
            property_id: null,
            app_target: null,
            is_roxy: false
        };

        if(self.all_properties.length){
            self.getAllProperties();
        }

        self.$timeout(function(){
            $('#appTargetSettingsModal').modal('show');
            self.initSelectizeAppTargetProperty();
        });
    }

    initSelectizeAppTargetProperty(){
        const self = this;

        self.clearSelectize('selectize_app_target_property');

        // Selectize documentation: https://github.com/selectize/selectize.js/blob/master/docs/usage.md
        let $select = $('#selectize_app_target_property').selectize({
            valueField: 'id',
            labelField: 'property_name',
            searchField: ['property_name'],
            sortField: [{field: 'property_name', direction: 'asc'}],
            maxItems: 1,
            options: self.all_properties || [],
            placeholder: 'Search project by name…',
            onChange: function(value){
                // Selectize callback runs outside Angular's digest — wrap in $apply.
                self.$scope.$applyAsync(function(){
                    self.loadAppTargetForProperty(value);
                });
            }
        });
    }

    clearSelectize(id){
        if(!id) return;

        try{
            let selectize = $("#" + id)[0] && $("#" + id)[0].selectize;
            if(selectize) selectize.destroy();
        } catch(ex){
            console.log(ex);
        }
    }

    loadAppTargetForProperty(propertyId){
        const self = this;

        self.appTargetSettingsErrors = {};
        if(!propertyId){
            self.appTargetSettingsParams.property_id = null;
            self.appTargetSettingsParams.app_target = null;
            self.appTargetSettingsParams.is_roxy = false;
            return;
        }

        let property = self.all_properties.find(x => x.id == propertyId);
        // Roxy is detected by developer named_id when the API exposes it; otherwise
        // we rely on the server's 422 guard. developer_name is always present but
        // is a display string, not stable for matching.
        let isRoxy = property
            && (property.developer_named_id === 'roxy-pacific-holdings-limited');

        self.appTargetSettingsParams = {
            property_id: propertyId,
            app_target: null,
            is_roxy: isRoxy
        };

        if(isRoxy){
            // Server will refuse the PUT with 422 — short-circuit on the client too.
            return;
        }

        let url = "sec/super/properties/" + propertyId + "/key-handover-settings/app-target";

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.appTargetSettingsParams.app_target =
                (response.data && response.data.app_target) || 'key_collection_by_ss';
        });
    }

    saveAppTargetSettings(){
        const self = this;

        self.appTargetSettingsErrors = {};
        let params = self.appTargetSettingsParams || {};

        if(!params.property_id){
            self.appTargetSettingsErrors.property_id = "Please select a project.";
            return;
        }
        if(params.is_roxy){
            self.appTargetSettingsErrors.app_target =
                "This setting does not apply to Roxy projects.";
            return;
        }
        if(!params.app_target){
            self.appTargetSettingsErrors.app_target = "Please pick an app target.";
            return;
        }

        let url = "sec/super/properties/" + params.property_id + "/key-handover-settings/app-target";
        let body = { app_target: params.app_target };

        loading(true);
        self.SSHttpService.putAPIRequest(url, body).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            $('#appTargetSettingsModal').modal('hide');
            self.SSAlertService.success('Success!', 'KeyHandover QR app target updated.');
        });
    }
}

SuperPropertyViewController.$inject = ['$scope', '$timeout', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSUserService', 'SSConfigService', 'SSConfirmationService'];
app.controller('SuperPropertyViewController', SuperPropertyViewController);

